import Vue from "vue"
import Vuex from "vuex"

import d2admin, { storeResets } from "./modules/d2admin"
import goodsInfoData from "./modules/goodsInfoData"
import FinancialRules from "./modules/FinancialRules"
Vue.prototype.$StoreReset = function () {
  return new Promise((resolve) => {
    storeResets.forEach((reset) => this.dispatch(reset))
    resolve()
  })
}
Vue.use(Vuex)

const isProd = process.env.NODE_ENV === "production"
// console.log(isProd)
if (!isProd) {
  Vue.config.devtools = true
}

export default new Vuex.Store({
  modules: {
    d2admin,
    goodsInfoData,
    FinancialRules
  }
})
